import { Type } from '@angular/core';

export class CrudFieldItemService {

  constructor(public component: Type<any>, public data: any) { }
}